module.exports = __webpack_public_path__ + "static/img/secret-slim.f1ba03a6.png";